import { Injectable } from '@angular/core';
import { HttpClientService } from '../../../../lib/http/http-client.service';
import { SubscriptionService } from '../../../../shared/services/subscription.service';
import { FileUploadModel } from '../Models/BuyerUploadModel';
import { CommonService } from '../../../../shared/services/common.service';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class BuyerUploadService {
  constructor(private http: HttpClientService, commonService: CommonService) {
    commonService.getServiceRequestFileConfig(environment.CommunityLotPictureSizePerFile).subscribe(x =>
      commonService.CommunityLotPictureSizePerFile.next(x && x.Value ? x.Value : 4)
    );
  }

  public getBuyerUploadInterfaceListByBuyerId(communityLotId: number, contractId: number) {
    return this.http.get('/BuyerUploadInterface/GetBuyerUploadInterfaceListByBuyerId?CommunityLotId=' + communityLotId + "&&ContractId=" + contractId);
  }

  public getProject() {
    return this.http.get('/BuyerUploadInterface/GetProject');
  }

  public getCommunityProjectId(projectId: number) {
    return this.http.get('/BuyerUploadInterface/GetCommunityByProjectId?ProjectID=' + projectId);
  }

  public getConstructionMilestoneByCommunityLotId(communityLotId: number) {
    return this.http.get('/BuyerUploadInterface/GetConstructionMilestoneByCommunityLotId?CommunityLotId='
      + communityLotId);
  }

  public getBuyerUploadInterfaceListByCommunityLotId(communityLotId: number, taskId: number, contractId: number) {
    return this.http.get('/BuyerUploadInterface/GetBuyerUploadInterfaceListByCommunityLotId?CommunityLotId='
      + communityLotId + "&&TaskId=" + taskId + "&&ContractId=" + contractId);
  }

  public deleteCommunityLotPictureByCommunityLotId(uploadedFiles: FileUploadModel, communityLotId: number, taskId: number, contractId: number) {
    return this.http.get('/BuyerUploadInterface/DeleteCommunityLotPictureByCommunityLotId?CommunityLotId='
      + communityLotId + "&&TaskId=" + taskId +
      "&&CommunityLotPictureId=" + uploadedFiles.CommunityLotPictureId
      + "&&ImageName=" + uploadedFiles.ImageName + "&&ContractId=" + contractId);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/buyer-upload-section/services/buyer-upload.service.ts